<template>
  <div>
    <ExternalPatientSearch />
  </div>
</template>

<script>
import ExternalPatientSearch from './ExternalPatientSearch.vue'

export default {
  name: 'ExternalPatient',
  components: { ExternalPatientSearch },
}
</script>
